import locales from "@/utils/locales/locales.json";
class LocaleUtil {
  constructor() {
    this.selectedLocales = {};
    this.short = "short";
    this.dash = "dash";
    this.underscore = "underscore";
  }
  locales() {
    return [...locales];
  }

  getSelectedLocales() {
    return Object.values(this.selectedLocales);
  }

  addWidgetTranslationLocale(uuid, id, objLocale) {
    if (this.currentUuid !== uuid) {
      this.currentUuid = uuid;
      this.selectedLocales = {};
    }
    const locale = objLocale ? objLocale.locale : null;
    if (locale) {
      if (locale.length === 2) {
        // short locale
        this.selectedLocales[`${id}-${this.short}`] = objLocale;
      } else {
        // long locale, add but do not allow select same locale with dash and underscore
        // Example: if selected en_US it should not allow to select en-US
        const separator = locale.includes("-") ? "-" : "_";
        const arr = locale.split(separator);
        // add both to not allow selection of locale with dash or underscore when either one is selected
        this.selectedLocales[`${id}-${this.dash}`] = {
          locale: `${arr[0]}-${arr[1]}`
        };
        this.selectedLocales[`${id}-${this.underscore}`] = {
          locale: `${arr[0]}_${arr[1]}`
        };
      }
    } else {
      delete this.selectedLocales[`${id}-${this.short}`];
      delete this.selectedLocales[`${id}-${this.dash}`];
      delete this.selectedLocales[`${id}-${this.underscore}`];
    }
  }

  geLocaleVariations(locale) {
    const variants = {};
    let parts = [];
    if (locale.includes("-")) {
      parts = locale.split("-");
    } else {
      parts = locale.split("_");
    }
    variants.short = parts[0];
    if (parts.length > 1) {
      variants.dashFormat = `${parts[0]}-${parts[1]}`;
      variants.underscoreFormat = `${parts[0]}_${parts[1]}`;
    }
    return variants;
  }
}

export default new LocaleUtil();
